import { CircularProgress } from '@material-ui/core';
import React from 'react';

const BTNLoader = ({ color }) => {
  return <CircularProgress color={color} style={{ width: 20, height: 20 }} />;
};

export default BTNLoader;
